<div class="row action-toolbar">
    <div class="col-12">
        <form class="form-inline">
            <action-toolbar-count [grid]="usersGrid"></action-toolbar-count>
            <action-toolbar-search name="search" [(ngModel)]="usersGrid.filter"></action-toolbar-search>
        </form>
    </div>
</div>
<div class="row">
    <div class="col-12">
        <wj-flex-grid id="gridUsers" #gridUsers appAutoSize (initialized)="usersGrid.initialize(gridUsers)" [itemsSource]="usersGrid.view">
            <wj-flex-grid-filter></wj-flex-grid-filter>
            <wj-flex-grid-column
                [header]="'Accepted Notifications'"
                [binding]="'acceptedNotifications'"
                [width]="135"
            ></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'User Name'" [binding]="'displayName'" [width]="'*'"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Phone'" [binding]="'phone'" [width]="'*'"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Email'" [binding]="'email'" [width]="'*'"></wj-flex-grid-column>
            <wj-flex-grid-column
                [header]="'Last Login'"
                [binding]="'lastLoginDate'"
                [width]="'*'"
                [format]="'MM/dd/yyyy hh:mm tt'"
            ></wj-flex-grid-column>
        </wj-flex-grid>
    </div>
</div>
